import {Inject, Pipe, PipeTransform} from '@angular/core';
import {I18NEXT_SERVICE, ITranslationService} from 'angular-i18next';
import {formatNumber} from 'app/core/helpers/number';

@Pipe({
    name: 'numberFormat',
    pure: false,
})
export class NumberFormatPipe implements PipeTransform {
    constructor(@Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService) {}

    transform(value: number, fraction: number = 0, integer: number = 1, minimumFractionDigits?: number): string {
        return formatNumber(value || 0, fraction, integer, this.i18NextService.language, minimumFractionDigits);
    }
}
